
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[studyProgram]/courses",
      function () {
        return require("private-next-pages/[studyProgram]/courses/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[studyProgram]/courses"])
      });
    }
  